var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PermissionValidation',{attrs:{"marketId":_vm.marketId,"rule":"enableApproveSettingBilling"}},[_c('approve-list-setting',{attrs:{"loading":_vm.isMainLoading,"subType":"billing_setting","approveTasks":_vm.approveTasks},on:{"onInit":_vm.getApproveTasksByMarket}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }